import { render, staticRenderFns } from "./ListSupervisor.vue?vue&type=template&id=20c18844&"
import script from "./ListSupervisor.vue?vue&type=script&lang=js&"
export * from "./ListSupervisor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports